import styled from "styled-components";
import { Color, breakpoints, ColorDark } from "@/shared/Constants";
import { cardMixin } from "@/widgets/Container/Templates/mixin";

export const ContentList = styled.ul`
  display: grid;
  grid-template-columns: repeat(4, 314px);
  gap: 20px;
  li {
    ${breakpoints.phone} {
      border-bottom: 1px solid #e0e0e0;
      margin-bottom: 15px;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          border-bottom: 1px solid ${ColorDark.greySeparator};
        }
      }
      &::before,
      &::after {
        display: none;
      }
    }
  }
  article {
    > div {
      height: 330px;
      ${breakpoints.phone} {
        height: auto;
      }
      .mt {
        .volanta {
          display: none;
        }
        /* .date{
          display:block;
        } */
        h2 {
          max-height: 99px;
          overflow: hidden;
        }
      }
    }
  }
  ${breakpoints.tablet} {
    grid-template-columns: repeat(3, 314px);
  }
  ${breakpoints.phone} {
    display: flex !important;
    flex-direction: column;
    width: 100%;
    grid-template-columns: auto !important;
    grid-area: auto !important;
    height: auto;
    li {
      height: auto;
    }
  }
  .bannerList {
    height: auto;
    overflow: hidden;
  }
`;

export const Card = styled.li`
  ${cardMixin}
  &:not(:last-child)::before {
    height: 95%;
  }
  &:not(:nth-last-child(-n + 2))::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: -10px;
    width: 113%;
    height: 1px;
    background-color: #e0e0e0;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        background-color: ${ColorDark.greySeparator};
      }
    }
  }
  &:nth-child(even)::after {
    left: -21px;
    width: 109%;
  }

  &:nth-of-type(4n)::before {
    display: none;
  }
  &:nth-of-type(3n)::after {
    width: 111%;
    left: -17px;
  }
`;
